import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=e46dd914&"
import script from "./AboutContent.vue?vue&type=script&lang=js&"
export * from "./AboutContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports